export function convertBaseToDisplay(reading: number, baseToDisplayFormula: string): number {
  const formula = parseFormula(baseToDisplayFormula)
  const output = evaluateFormula(formula, reading)
  return output
}

function parseFormula(formulaText: string) {
  const formula: (string | number)[] = []

  let index = 0
  const max = formulaText.length
  while (index < max) {
    const op = getSubstring(formulaText, index, 1)
    switch (op) {
      case '@':
      case '*':
      case '/':
      case '+':
      case '-':
        formula.push(op)
        index++
        break

      case '[':
        formula.push('N')
        index++
        const length = formulaText.indexOf(']', index) - index
        const value = getSubstring(formulaText, index, length)
        formula.push(value)
        index += length + 1
        break

      default:
        index++
        break
    }
  }

  return formula
}

function evaluateFormula(formula: (string | number)[], input: number): number {
  const stack: number[] = []

  let index = 0
  const count = formula.length

  while (index < count) {
    const op = formula[index]
    switch (op) {
      case '@':
        stack.push(input)
        index++
        break

      case 'N':
        index++
        const value = Number(formula[index])
        stack.push(value)
        index++
        break

      case '*':
      case '/':
      case '+':
      case '-':
        const y: number = stack.pop() || 0
        const x: number = stack.pop() || 0
        let result: number = 0
        switch (op) {
          case '*':
            result = x * y
            break
          case '/':
            result = y === 0 ? Infinity : x / y
            break
          case '+':
            result = x + y
            break
          case '-':
            result = x - y
            break
        }
        stack.push(result)
        index++
        break

      default:
        index++
        break
    }
  }

  const output = stack.pop()

  return output || 0
}

function getSubstring(str: string, start: number, length: number): string {
  return str.slice(start, start + length)
}
